import React from 'react'
import PropTypes from 'prop-types'
import * as Component from './Divider.styles'

/** A divider is a thin line that groups content in lists and layouts */
const Divider = ({ className, orientation, role, margin }) => (
  <Component.Root
    className={ className }
    orientation={ orientation }
    role={ role }
    margin={ margin }
  />
)

Divider.defaultProps = {
  orientation: 'horizontal',
  role: 'separator',
}

Divider.propTypes = {
  /** The CSS class name of the wrapper element. */
  className: PropTypes.string,
  /** The divider orientation */
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  /** Add some additional margin */
  margin: PropTypes.number,
  /** The divider role */
  role: PropTypes.string,
}

export default Divider
